import { createErrorCodes } from '@shared/utils';
import { BOOTSTRAP_MESSAGES } from './BOOTSTRAP_MESSAGES';

export const BOOTSTRAP_ERROR_CODES = createErrorCodes(BOOTSTRAP_MESSAGES);
